import { Trans } from 'react-i18next'

import { Lock } from '@phosphor-icons/react'

import { FormatPrice } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const InfoMessage = ({ hasBankAccounts, orderAmount }) => {
  return (
    <Styles.Container>
      <p>
        {hasBankAccounts ? (
          <>
            <Trans>
              Selecciona la cuenta en la que quieres recibir tu <strong>transferencia instantánea</strong> de{' '}
            </Trans>
            <strong>
              <FormatPrice currency={orderAmount?.currency}>{orderAmount?.remaining_amount}</FormatPrice>
            </strong>{' '}
            con Reveni
          </>
        ) : (
          <>
            <Trans>
              Introduce tu número de cuenta para recibir una <strong>transferencia instantánea</strong> de{' '}
            </Trans>
            <strong>
              <FormatPrice currency={orderAmount?.currency}>{orderAmount?.summary_total_amount}</FormatPrice>
            </strong>
          </>
        )}
      </p>
      <p>
        <Lock size={12} weight="thin" />
        <span>
          <Trans>
            Tu información será tratada de manera <strong>segura y confidencial</strong>.
          </Trans>
        </span>
      </p>
    </Styles.Container>
  )
}

export default InfoMessage
